import api from '@/lib/axios';

export interface WorkspaceEntitlements {
  modules: string[];
  permissions: string[];
  plan: { code: string | null; name: string | null };
}

/**
 * Fetch workspace entitlements
 * 
 * @param workspaceId - The workspace ID
 * @returns Workspace entitlements including modules, permissions, and plan
 */
export async function fetchWorkspaceEntitlements(
  workspaceId: string
): Promise<WorkspaceEntitlements> {
  const { data } = await api.get<WorkspaceEntitlements>(
    `/workspaces/${workspaceId}/entitlements`
  );
  return data;
}

/**
 * Update workspace entitlements
 * 
 * @param workspaceId - The workspace ID
 * @param modules - Array of module keys to enable
 * @returns Updated entitlements
 */
export async function updateWorkspaceEntitlements(
  workspaceId: string,
  modules: string[]
): Promise<WorkspaceEntitlements> {
  const { data } = await api.put<WorkspaceEntitlements>(
    `/workspaces/${workspaceId}/entitlements`,
    { modules }
  );
  return data;
}
